import {
  customFieldResourceTypeLabels,
  type CustomFieldType,
} from "@repo/app-types/entities/customField";
import {
  SimpleSelect,
  type SimpleSelectOption,
} from "@repo/ui/Select/simpleSelect";
import { type FC, useMemo } from "react";
import { useAllUserCustomFieldDefinitionsQuery } from "../../api/entities/userCustomField.js";

export interface UserCustomFieldSelectProps {
  label?: string;
  placeholder?: string;
  noneLabel?: string;
  selectedCustomFieldDefinitionId: string | null;
  onChange: (customFieldDefinitionId: string | null) => void;
  fieldTypes?: readonly CustomFieldType[];
}

export const UserCustomFieldSelect: FC<UserCustomFieldSelectProps> = (
  props,
) => {
  const { data: customFieldDefinitions, isLoading } =
    useAllUserCustomFieldDefinitionsQuery();

  const options: readonly SimpleSelectOption<string | null>[] = useMemo(
    () => [
      {
        value: null,
        label: props.noneLabel || "No custom field",
      },
      ...(customFieldDefinitions ?? [])
        .filter((definition) =>
          props.fieldTypes
            ? props.fieldTypes.includes(definition.field_type)
            : true,
        )
        .map((definition) => ({
          value: definition.id,
          label: `[${customFieldResourceTypeLabels[definition.resource_type]}] ${definition.display_name}`,
        })),
    ],
    [customFieldDefinitions, props.noneLabel, props.fieldTypes],
  );

  const handleChange = (newValue: string | null) => {
    props.onChange(newValue);
  };

  return (
    <SimpleSelect
      label={props.label || "Custom field"}
      isDisabled={isLoading}
      placeholder={props.placeholder || "Select a custom field"}
      options={options}
      value={props.selectedCustomFieldDefinitionId}
      onChange={handleChange}
    />
  );
};
